export default {
  'status.active': 'Aktif',
  'status.passive': 'Pasif',
  'status.deleted': 'Silinmiş',
  'status.pendingEmailVerification': 'E-Posta Doğrulaması Bekleniyor',
  'status.pendingInvitation': 'Bekleyen Davet',
  'status.unknown': 'Bilinmiyor',
};
